var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.25 35.75C27.915 35.75 35.75 27.915 35.75 18.25C35.75 8.58502 27.915 0.75 18.25 0.75C8.58502 0.75 0.75 8.58502 0.75 18.25C0.75 27.915 8.58502 35.75 18.25 35.75Z",
    stroke: "#FF4A4A",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3160_273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7695 8.25H9.72656C8.91016 8.25 8.25 8.89453 8.25 9.69141V26.8047C8.25 27.6016 8.91016 28.25 9.72656 28.25H26.7695C27.5859 28.25 28.25 27.6016 28.25 26.8086V9.69141C28.25 8.89453 27.5859 8.25 26.7695 8.25ZM14.1836 25.293H11.2148V15.7461H14.1836V25.293ZM12.6992 14.4453C11.7461 14.4453 10.9766 13.6758 10.9766 12.7266C10.9766 11.7773 11.7461 11.0078 12.6992 11.0078C13.6484 11.0078 14.418 11.7773 14.418 12.7266C14.418 13.6719 13.6484 14.4453 12.6992 14.4453ZM25.293 25.293H22.3281V20.6523C22.3281 19.5469 22.3086 18.1211 20.7852 18.1211C19.2422 18.1211 19.0078 19.3281 19.0078 20.5742V25.293H16.0469V15.7461H18.8906V17.0508H18.9297C19.3242 16.3008 20.293 15.5078 21.7344 15.5078C24.7383 15.5078 25.293 17.4844 25.293 20.0547V25.293Z",
    fill: "#424242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3160_273"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.25,
    y: 8.25,
    width: 20,
    height: 20,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.2d4138729b79bf80a53141711380b594.svg";
export { ForwardRef as ReactComponent };